module.exports = __webpack_public_path__ + "static_pc/img/gj02.f1cd7a96.jpg";